module.exports = __webpack_public_path__ + "img/step_2.10cd3ad7.webp";